import {useClerk} from '@clerk/react'
import {useEffect} from 'react'

export function Logout() {
  const {signOut} = useClerk()

  useEffect(() => {
    signOut({redirectUrl: '/auth/login'})
  }, [])

  return null
}
